export const DEFAULT_APP_PROPERTIES = {
  appSessionKey: {
    type: String,
    required: false,
    //default: "2-21", // replace with null for development mode
    default: null,
  },
  uuid: {
    type: String,
    required: false,
    //default: "01028419a3c8695457e24cfcd0c6841a132874ee", // replace with null for development mode
    default: null,
  },
  routes: {
    type: Object,
    required: false,
    default: {
      fulfilment: "/fulfilment",
      unlinked: "/unlinked",
    },
  },
  baseURL: {
    type: String,
    required: false,
    //default: "/#pmx/payments", // replace with / for development mode
    default: "/",
  },
  server: {
    type: String,
    required: false,
    default: "https://pmx2dev3.parentmail.co.uk/api",
  },
  hashHistory: {
    type: Boolean,
    required: false,
    //default: true, // replace with false for development mode
    default: false,
  },
  developmentMode: {
    type: Boolean,
    required: false,
    default: false,
  },
  credentials: {
    type: Object,
    required: false,
    default: {
      type: "PMX",
      token: "",
      appSessionKey: "200001110-23420"
    },
  },
};
